import { render, staticRenderFns } from "./GanttSettingsModal.vue?vue&type=template&id=3b764422&scoped=true"
import script from "./GanttSettingsModal.vue?vue&type=script&lang=js"
export * from "./GanttSettingsModal.vue?vue&type=script&lang=js"
import style0 from "./GanttSettingsModal.vue?vue&type=style&index=0&id=3b764422&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b764422",
  null
  
)

export default component.exports